import PageTemplate from '../containers/common/PageTemplate';

import Container from '../containers/favorite';

export default function Favorite() {
  return (
    <>
      <PageTemplate>
        <Container />
      </PageTemplate>
    </>
  );
}
